module.exports = __webpack_public_path__ + "Flag-348.8ed2c97197279599488f7db5a1fcf962.svg";